// Send a message to the parent
export function sendMessage(msg: { type: string, mess: string }) {
    // Make sure you are sending a string, and to stringify JSON
    console.log('send message to parrent : ', msg);
    window.parent.postMessage(msg, '*');
}

export function roundToFixed(num: any) {
    return Math.round(num * 100) / 100;
}

export function wrapToHtml(text: string, element?: 'div' | 'span') {
    const el = document.createElement(element ? element : 'span');
    el.innerHTML = text;
    return el;
}